<template>
    <div>
        <div class="tw-rounded tw-bg-white tw-shadow-md tw-p-8">
            <h5 class="tw-font-semibold tw-text-4xl tw-pb-6">{{isFullList ? $word.all_matches :
                $word.find_a_match}}</h5>

            <div class="tw-grid tw-grid-cols-2 tw-gap-8">
                <div>
                    <div class="tw-mb-1 tw-font-bold">{{$word.i_am}}:</div>
                    <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                        <button class="tw-block filter-button" :class="{'--active' : filters.genders.iAm === 'man'}"
                            v-on:click="filters.genders.iAm = 'man'">
                            <i class="bx bx-male"></i>
                            <span>{{$word.man}}</span>
                        </button>
                        <button class="tw-ml-1 filter-button" :class="{'--active' : filters.genders.iAm === 'woman'}"
                            v-on:click="filters.genders.iAm = 'woman'">
                            <i class="bx bx-female"></i>
                            <span>{{$word.woman}}</span>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="tw-mb-1 tw-font-bold">{{$word.looking_for}}:</div>
                    <div class="tw-grid tw-grid-cols-2 tw-gap-2">
                        <button class="tw-block filter-button"
                            :class="{'--active' : filters.genders.lookingFor === 'man'}"
                            v-on:click="filters.genders.lookingFor = 'man'">
                            <i class="bx bx-male"></i>
                            <span>{{$word.man}}</span>
                        </button>
                        <button class="tw-ml-1 filter-button"
                            :class="{'--active' : filters.genders.lookingFor === 'woman'}"
                            v-on:click="filters.genders.lookingFor = 'woman'">
                            <i class="bx bx-female"></i>
                            <span>{{$word.woman}}</span>
                        </button>
                    </div>
                </div>

                <div>
                    <div class="tw-mb-1 tw-font-bold">{{$word.ages}}:</div>
                    <div class="tw-flex tw-items-center tw-space-x-2">
                        <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2"
                            v-model="filters.startAge">
                            <option :value="age" v-for="age in states.ages">{{age}}</option>
                        </select>
                        <div class="tw-font-bold">—</div>
                        <select class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2"
                            v-model="filters.endAge">
                            <option :value="age" v-for="age in states.ages">{{age}}</option>
                        </select>
                    </div>
                </div>

                <div>
                    <div class="tw-mb-1 tw-font-bold">{{$word.countries}}:</div>
                    <div>
                        <v-select-favorite-countries v-model="filters.favoriteCountries"/>
                    </div>
                </div>
            </div>
             <div class="tw-grid tw-grid-cols-3 tw-gap-8 mt-5">
                 <div>
                    <div class="tw-mb-1 tw-font-bold">Name</div>
                    <input type="text" class=" form-input" v-model="filters.name">
                </div>
                <div>
                    <div class="tw-mb-1 tw-font-bold">Username</div>
                    <input type="text" class=" form-input" v-model="filters.username">
                </div>
                <div>
                    <div class="tw-mb-1 tw-font-bold">Email</div>
                    <input type="text" class="form-input" v-model="filters.email">
                </div>
             </div>
            <div class="tw-grid tw-grid-cols-2 tw-gap-8 mt-5">

                <template v-if="states.advance">

                    <div class="tw-flex tw-col-span-2 tw-flex-wrap">
                        <button v-for="tab in ['Height','Weight','Have Children',...store.optionFilterGroups]"
                            v-on:click.prevent="states.advance_tab = store.groupKey(tab)"
                            :class="{'tw-text-primary-500 tw-font-semibold tw-border-primary-500' : states.advance_tab === store.groupKey(tab)}"
                            class="tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-bg-transparent tw-border-solid tw-border-b-2 tw-border-gray-200 hover:tw-border-primary-500 tw-px-2 tw-py-2"
                        >
                            {{tab}}
                            <span class="tw-text-primary-600 tw-font-extrabold"
                                v-if="store.criteriaIsActive(tab)">*
                            </span>
                        </button>
                        <div class="tw-flex-grow tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-bg-transparent tw-border-solid tw-border-b-2 tw-border-gray-200 hover:tw-border-primary-500 tw-px-2 tw-py-2"></div>
                    </div>
                    <div v-show="states.advance_tab === 'height'">
                        <!--<div class="tw-mb-1 tw-font-bold">{{$word.height}}:</div>-->
                        <div class="tw-flex tw-items-center tw-space-x-2">
                            <input v-model="filters.criteria.height.from" type="text"
                                class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2">
                            <div class="tw-font-bold">—</div>
                            <input v-model="filters.criteria.height.to" type="text"
                                class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2">
                        </div>
                    </div>
                    <div v-show="states.advance_tab === 'weight'">
                        <!--<div class="tw-mb-1 tw-font-bold">{{$word.weight}}:</div>-->
                        <div class="tw-flex tw-items-center tw-space-x-2">
                            <input v-model="filters.criteria.weight.from" type="text"
                                class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2">
                            <div class="tw-font-bold">—</div>
                            <input v-model="filters.criteria.weight.to" type="text"
                                class="tw-flex-1 tw-rounded tw-border tw-border-solid tw-border-gray-200 tw-p-2">
                        </div>
                    </div>

                    <div v-show="states.advance_tab === 'haveChildren'" class="tw-col-span-2">
                        <!--<div class="tw-mb-2 tw-font-bold">{{$word.have_children}}:</div>-->
                        <div class="tw-grid tw-grid-cols-4 tw-gap-1">
                            <label class="tw-flex tw-items-center tw-space-x-2">
                                <input name="have-children" type="radio" v-model="filters.criteria.haveKids"
                                    :value="true" class="tw-w-4 tw-h-4">
                                <div>{{$word.yes}}</div>
                            </label>
                            <label class="tw-flex tw-items-center tw-space-x-2">
                                <input name="have-children" type="radio" v-model="filters.criteria.haveKids"
                                    :value="false" class="tw-w-4 tw-h-4">
                                <div>{{$word.no}}</div>
                            </label>
                        </div>
                    </div>

                    <template v-for="filterGroup in store.optionFilterGroups">

                        <div v-show="states.advance_tab === store.groupKey(filterGroup)" class="tw-col-span-2">
                            <!--<div class="tw-mb-2 tw-font-bold">{{$word[_.snakeCase(filterGroup)]}}:</div>-->
                            <div class="tw-flex tw-flex-wrap tw-items-center tw-space-x-3">
                                <button class="tw-border-none tw-bg-gray-100 tw-mb-3 tw-rounded tw-block tw-mb-0 tw-font-normal tw-flex tw-items-center tw-space-x-1"
                                    :class="{'tw-bg-primary-500 tw-text-white' : store.optionIsActive(filterGroup,item)}"
                                    v-on:click="store.toggleOption(filterGroup,item)"
                                    v-for="item in store.options(filterGroup)">
                                    <div>
                                        {{item.title}}
                                    </div>
                                </button>
                            </div>
                        </div>

                    </template>
                </template>

                <div class="tw-flex tw-items-center tw-justify-between tw-col-span-2">
                    <div class="tw-flex tw-items-center tw-space-x-6">
                        <button v-on:click="() => store.toggleAdvance()"
                            class="tw-p-0 tw-border-none tw-text-blue-600 tw-font-semibold tw-bg-transparent">
                            <span v-if="states.advance">{{$text.show_less}}</span>
                            <span v-else>{{$text.show_more}}</span>
                        </button>
                        <button v-if="store.criteriaFilterCount() !== 0" v-on:click="() => store.resetCriteria()"
                            class="tw-p-0 tw-border-none tw-text-red-600 tw-font-semibold tw-bg-transparent"
                        >{{$text.reset_extra_filters}} ({{store.criteriaFilterCount()}})
                        </button>
                    </div>
                    <button v-on:click.prevent="() => store.search()"
                        class="tw-rounded tw-bg-red-600 tw-text-white tw-font-bold tw-px-6 tw-py-2 tw-border-none">
                        {{$word.find}}
                    </button>
                </div>
            </div>
        </div>

        <match-seeker-results class="tw-mt-5" :is-full-list="isFullList"/>

    </div>
</template>
<script>
    import store from './match-seeker-store'
    import MatchSeekerResults from './match-seeker-results'

    export default {
        components: {
            MatchSeekerResults,
        },
        created() {
            store.init()
            this.store = store
            this.states = store.states
            this.filters = store.states.filters
        },
        props: {
            isFullList: {
                default: false,
            },
        },
        data: v => ({}),
        methods: {
            optionSelected(option) {
                return _.chain(store.states.filters.favoriteCountries)
                    .filter(country => country.id === option.id)
                    .value().length !== 0
            }
        }
    }
</script>
<style>
    .filter-button.--active {
        @apply tw-bg-primary-500 tw-text-white;
    }

    .filter-button {
        @apply tw-border-2 tw-border-solid tw-border-primary-500 tw-py-2 tw-text-center tw-bg-white tw-text-primary-500 tw-font-semibold tw-rounded;
    }

    /*span.multiselect__single {*/
    /*    @apply tw-hidden !important;*/
    /*}*/
    .form-input{
        @apply tw-rounded tw-w-full tw-border tw-border-gray-300 tw-border-solid tw-p-2 focus:tw-border-primary-500 focus:tw-ring focus:tw-ring-primary-500 focus:tw-ring-opacity-10;
    }
</style>
